import { render, staticRenderFns } from "./mealDetailModal.vue?vue&type=template&id=0ba0333a&"
import script from "./mealDetailModal.vue?vue&type=script&lang=js&"
export * from "./mealDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports